/**
 * Shared styles for purchase page presets
 */

/**
 * Swiper container styles - targets Swiper's internal classes (third-party library integration)
 * Used by StickyTabs and HeroStickyHeader for tab navigation
 */
export const swiperContainerStyles = {
  "& .swiper-slide": {
    width: "fit-content",
    minWidth: "fit-content",
    maxWidth: "fit-content",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginLeft: "4px",
  },
  "& .swiper-container": {
    marginLeft: "0 !important",
    marginRight: "0 !important",
    width: "100%",
  },
  "& .swiper-button-disabled": {
    display: "none",
  },
};
